import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedDataService } from 'ngx-paf-common';
import { AuthState } from '../Models_Extranet/AuthState';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    public sharedSvc:SharedDataService,
    private oauthService:OAuthService
  ) { }


  async loadDiscoveryDocument():Promise<void>{
    await this.oauthService.loadDiscoveryDocument();
  }

  UpdateGlobalClaims():void {
    const claims: any = this.oauthService.getIdentityClaims();
   if (!!claims && !this.sharedSvc.loggedId) {
      this.sharedSvc.loggedId = claims['sub'];
    }
  }

  getAccessToken():string{
    return this.oauthService.getAccessToken();
  }


  CanActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.oauthService.hasValidAccessToken()) {
        const authState: AuthState = {
          url: route.url.toString(),
          baseApiUrl: this.sharedSvc.pafEnvironment.apiBaseUrl,
          clientUrl: window.location.origin,
          queryParams: Object.keys(route.queryParams).map((k: string) => ({
            Key: k, 
            Value: route.queryParams[k]
          }))
        };    
        const pafState: string = encodeURIComponent(JSON.stringify(authState));
    
        this.oauthService.initLoginFlow(`?pafState=${pafState}`);
        return false;
      } else {
        this.UpdateGlobalClaims();
        return true;
      }
  }

}
